// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {4: "no-match","w": "about",}[chunkId] + "." + {4: "95aead35e9ac5d3c","w": "9e9e0410e6a2db7e",}[chunkId] + ".js"
}